<div class="dashboard group-session">
  <top-bar></top-bar>

  @if (loading) {
    <app-loading-indicator />
  } @else if (groupSession && activeMember) {
    <div class="group-toolbar">
      <div class="group-tabs" role="tablist" aria-label="Group session clients">
        @for (member of members; track member.SessionID) {
          <button
            type="button"
            role="tab"
            class="group-tab"
            [class.active]="activeMember.SessionID === member.SessionID"
            [class.finished]="!!member.FinishedDate"
            [disabled]="!!member.DeletedDate"
            [attr.aria-selected]="activeMember.SessionID === member.SessionID"
            (click)="selectMember(member)"
          >
            {{ member.PatientName || ('Client #' + member.PatientID) }}
            @if (member.FinishedDate) {
              <i class="pi pi-check-circle" title="Session ended"></i>
            }
          </button>
        }
      </div>

      <div class="group-actions">
        @if (hasUnstartedSessions()) {
          <button
            pButton
            type="button"
            class="button-start"
            [label]="hasStartedSessions() ? 'Start Remaining' : 'Start Group'"
            [disabled]="starting"
            (click)="startAll()"
          ></button>
        }
        @if (
          activeMember.StartedDate &&
          !activeMember.FinishedDate &&
          !activeMember.DeletedDate
        ) {
          <button
            pButton
            type="button"
            class="button-end"
            label="End"
            (click)="endActive()"
          ></button>
        }
      </div>
    </div>

    <staff-home
      [groupMode]="true"
      [groupPatientID]="activeMember.PatientID"
      [groupSessionID]="activeMember.SessionID"
      (groupSessionFinished)="onActiveSessionFinished($event)"
    ></staff-home>
  } @else {
    <div class="group-empty">No clients are available for this group session.</div>
  }
</div>
